import { useContext, useState } from "react";
import NonIdealNew from "../../common/NonIdealNew";
import { LanguageContext } from "../../../context/LanguageContext";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { InnerWrapper, MainContainer, TitleAndActionBox } from "../../common";
import withObservables from "@nozbe/with-observables";
import { BusinessOverviewTransactionsCount } from "../../../database/helpers/invoice";
import { useAuthContext } from "../../../context/AuthContext";
import { VideoModal } from "../../common/Modals";
import RecentTransactionList from "../../container/BusinessOverview/BusinessOverviewList/RecentTransactionList";

const BusinessOverviewTransactions = ({
  businessOverviewTransactionsListCount,
}) => {
  const [I18n] = useContext(LanguageContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { business, user } = useAuthContext();
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  const handleAddQuickSale = () => {
    triggerLogEvent(analytics, "quick_sale_create");
    navigate("/QuickSale/QuickSaleForm");
  };

  const handleAddQuickSaleOrExpense = (type) => {
    triggerLogEvent(analytics, "quick_sale_create");
    navigate(
      type == "in" ? "/QuickSale/QuickSaleForm" : "/Expense/ExpenseForm",
      {
        state: {
          pathname: location.pathname,
        },
      },
    );
  };

  const isNonIdeal = businessOverviewTransactionsListCount <= 0;
  return (
    <MainContainer fluid className="quickSalePage">
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title: I18n.view_transactions,
              isBack: true,
              onBack: () => navigate("/BusinessOverview"),
            }}
          ></TitleAndActionBox>
          <InnerWrapper className="innerWrapper newInnerWrapper">
            {isNonIdeal ? (
              <NonIdealNew
                title={`${I18n.sales}, ${I18n.expenses}, ${I18n.profit}`}
                subtitle={
                  I18n.Add_salesexpenses_to_see_your_PL_and_grow_your_profits
                }
                button1Title="add_expense"
                onButton1Click={() => handleAddQuickSaleOrExpense("out")}
                loading={false}
                disabledOne={false}
                buttonOneId={"create_expense"}
                listButton2Title="add_sale"
                onListButton2Click={() => handleAddQuickSaleOrExpense("in")}
              />
            ) : (
              <RecentTransactionList
                isShowAll={true}
                business={business}
                user={user}
              />
            )}
          </InnerWrapper>
        </Grid>
      </Grid>

      <VideoModal
        open={isVideoModalOpen}
        onClose={() => setIsVideoModalOpen(false)}
        title={I18n.one_click_sale_faster_transaction}
        subtitle={I18n.speed_up_sales_reduce_wait_times}
        youtubeEmbedUrl="https://www.youtube.com/embed/KpMpGauNeDc?si=_xvfwB-A25WKNQO1"
        primaryButton={{
          text: I18n.add_quick_sale,
          onClick: handleAddQuickSale,
        }}
        secondaryButton={{ text: I18n.close }}
      />
    </MainContainer>
  );
};

const enhance = withObservables([], () => ({
  businessOverviewTransactionsListCount: BusinessOverviewTransactionsCount(
    localStorage.getItem("business_id"),
  ),
}));

export default enhance(BusinessOverviewTransactions);
